module.exports = __webpack_public_path__ + "img/1.6ff5da9f.jpg";